import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import * as DefaultCheck from 'petco-ui/elements/form/checkbox/Checkbox.styled';

const modifiers = {
  primary: ({ theme }) => ({
    styles: `
      background-color: ${theme.primary.main};
      color: white;
      span {
        color: yellow;
      }
    `,
  }),
  large: () => ({
    styles: `
      .checkbox__IconContainer {
        border-radius: .3125rem;
        height: 1.875rem;
        width: 1.875rem;
      }
    `,
  }),
};

export const Checkbox = styled(DefaultCheck.CheckStyled)`
  ${applyStyleModifiers(modifiers)};
`;

export const CheckField = styled(DefaultCheck.Check)`
  ${applyStyleModifiers(modifiers)};
`;

export const IconContainer = styled(DefaultCheck.IconContainer)`
  ${applyStyleModifiers(modifiers)};
`;
